import { ReferenceLine } from "recharts";

const NAMN = { samanslåing: "Samanslåing", deling: "Oppsplitting", kodeendring: "Ny kommunekode" };

let merke = [];

const samle = (par) => {
  const aar = new Map();
  par.forEach(([year, prefix, label]) => {
    const per = aar.get(year) || new Map();
    per.set(prefix, [...new Set([...(per.get(prefix) || []), label])]);
    aar.set(year, per);
  });
  return [...aar.entries()]
    .map(([year, per]) => ({
      year,
      label: `${[...per.entries()].map(([p, l]) => `${p}${l.join(" · ")}`).join(" · ")} ${year}`,
    }))
    .sort((a, b) => a.year - b.year);
};

const par = (data, prefix = "") => [
  ...(data?.endringar || []).filter((e) => NAMN[e.type]).map((e) => [e.year, prefix, NAMN[e.type]]),
  ...(data?.fylkesendring ? [[data.fylkesendring.year, prefix, "Nytt fylke"]] : []),
];

export const setEndringsMerke = (data) => {
  merke = samle(par(data));
};

export const setEndringsMerkeListe = (liste) => {
  merke = samle((liste || []).flatMap((d) => par(d, d?.kommune_name ? `${d.kommune_name}: ` : "")));
};

export const clearEndringsMerke = () => {
  merke = [];
};

/** Loddrette linjer i historikkgrafane på åra kommunen vart slått saman, delt, fekk ny kode eller nytt fylke. */
export const endringsLinjer = (data, { key = "year", yAxisId } = {}) => {
  if (merke.length === 0 || !data?.length) return null;
  const verdiar = data.map((d) => d?.[key]);
  return merke
    .map((m) => {
      const i = verdiar.indexOf(m.year) >= 0 ? verdiar.indexOf(m.year) : verdiar.indexOf(String(m.year));
      if (i < 0) return null;
      const x = verdiar[i];
      // legg teksten til venstre for linja når endringsåret ligg nær høgre kant, slik at han ikkje blir klipt
      const pos = i / Math.max(1, verdiar.length - 1) > 0.55 ? "insideTopRight" : "insideTopLeft";
      return (
        <ReferenceLine
          key={`endring-${m.year}`}
          x={x}
          {...(yAxisId ? { yAxisId } : {})}
          stroke="#B5832B"
          strokeDasharray="5 4"
          strokeWidth={1.5}
          isFront
          className="endring-linje"
          label={{ value: m.label, position: pos, fontSize: 9, fill: "#8A7340" }}
        />
      );
    })
    .filter(Boolean);
};
